const btn = {
  back: {
    icon: 'arrow-left',
    click(router) {
      router.back();
    }
  },
  filter: {
    icon: 'filter',
    text: '筛选'
  }
};

export const routes = [
  {
    navbar: {
      title: '数据',
      backgroundColor: '#050505'
      // right: btn.filter
    },
    name: 'pageData',
    page: () => import('../pages/data')
  },
  {
    name: 'pageDetection',
    page: () => import('../pages/detection')
  },
  {
    navbar: { title: '设备信息', backgroundColor: '#050505' },
    name: 'pageDevice',
    page: () => import('../pages/device')
  },
  {
    navbar: {
      title: '检测报告',
      backgroundColor: '#1a1a1a',
      left: btn.back
    },
    name: 'detectionReport',
    page: () => import('../pages/detection/report.vue')
  }
];

export const first = 'pageDetection';

export const routeMap = {};

export const comps = {};

export const tabbar = [
  { icon: 'data', route: 'pageData' },
  { icon: 'detection', route: 'pageDetection' },
  { icon: 'info', route: 'pageDevice' }
];

export const histories = [];

(function () {
  routes.forEach(e => {
    routeMap[e.name] = e;
    comps[e.name] = e.page;
  });
})();
